import { WORKSPACE_FRAME_PADDING } from '@components/v2/constants';
import { TOPBAR } from '@components/v2/layout/AppTemplate/appTemplate.consts';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const SHELL_ICON_BUTTON_ACTIVE_SX = (theme: Theme) => ({
  '&[data-active="true"]': {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.custom.layout.shell.buttonSelected,
    '&:hover': { backgroundColor: theme.palette.custom.layout.shell.buttonSelected },
  },
});

export const useHeaderStyles = makeStyles()((theme) => ({
  appBar: {
    height: TOPBAR.height,
    '&&': { background: theme.palette.background.default },
    boxShadow: 'none',
    position: 'relative',
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.text.primary,
  },
  shellIconButton: {
    '&:hover': { backgroundColor: theme.palette.custom.layout.shell.buttonHover },
  },
  toolbar: {
    height: TOPBAR.height,
    '&&': { minHeight: TOPBAR.height },
    padding: theme.spacing(0, WORKSPACE_FRAME_PADDING),
    paddingLeft: theme.spacing(1.5),
    gap: theme.spacing(1),
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
    },
  },
}));
